import React, { useState, useEffect } from "react";
import "./../../App.css";
import { createPO } from "../../Services/PoException";
import checkPONumber from "../../Services/PoGet";
import ServiceLevelService from "../../Services/ServiceLevelService";
import { fetchStores } from "../../Services/Store";
import {
  TextField,
  Button,
  Grid,
  Box,
  Select,
  ListItemText,
  Checkbox,
  MenuItem,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import loaderGif from "../../Assests/loader.gif";

const Store = ({ initialData = null, open }) => {
  //const [formData, setFormData] = useState({
  const initialFormData = {
    po_number: "",
    vendor_name: "",
    department_number: "",
    // store_number:"",
    store_list: [],
    client_name: "",
    vendor_email: "",
    freight_payer_id: "",
    bill_account_number: "",
    units: "",
    //supplier_site_id: "",
    service_level_id: "",
    expense_number: "",
    requester_name: "",
    requester_phone: "",
    requester_email: "",
    comment: "",
    approved_date: "",
    exception_routing_reason: "",
    vendor_ship_date: "",
    date_needed_store: "",
  };

  const [errors, setErrors] = useState({});
  const [poError, setPoError] = useState(null);
  const [loading, setLoading] = useState(false);
  // New state for store dropdown
  const [storeOptions, setStoreOptions] = useState([]);
  const [isLoadingStores, setIsLoadingStores] = useState(false);
  const [storeError, setStoreError] = useState(null);

  // Service level dropdown state
  const [serviceLevelOptions, setServiceLevelOptions] = useState([]);
  const [isLoadingServiceLevels, setIsLoadingServiceLevels] = useState(false);
  const [serviceLevelError, setServiceLevelError] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({}); // State to track field errors
  const [formData, setFormData] = useState(initialFormData);
  const [isFormDisabled, setIsFormDisabled] = useState(true);

  // Mock data for freight payer
  const freightPayerOptions = [
    { id: 1, name: "Buyer" },
    { id: 2, name: "Vendor" },
    { id: 3, name: "Store" },
  ];

  const exceptionRoutingOptions = [
    { id: 1, name: "Customer Request" },
    { id: 2, name: "Personal Appearance" },
    { id: 3, name: "Store Event" },
    { id: 4, name: "Trunck Show" },
    { id: 5, name: "Vendor Delayed Shipment" },
    { id: 6, name: "Catalog Drop" },
    { id: 7, name: "Out Of Stock" },
  ];
  const billToAccountOptions = [
    { id: 1, name: "Fedex Act 1886 23 204" },
    { id: 2, name: "Freight Collect" },
    { id: 3, name: "Vendor Pays Freight" },
    { id: 4, name: " Trunck Show" },
  ];

  console.log("storeOptions: ", storeOptions);
  useEffect(() => {
    const fetchStoreData = async () => {
      setIsLoadingStores(true);
      setStoreError(null);

      try {
        const response = await fetchStores(1, 100);
        console.log("Raw store data:", response.data);

        // Filter stores with exception_allowed set to 1
        const filteredStores = response.data.filter(
          (store) => store.exceptions_allowed === 1
        );
        // Log the filtered stores
        console.log("Stores with exceptions_allowed set to 1:", filteredStores);

        // Set the store options for the dropdown
        setStoreOptions(
          filteredStores.map((store) => ({
            id: store.store_id,
            number: store.store_number,
            name: `${store.store_number} - ${store.name || "Unknown"}`,
            units: store.units,
          }))
        );
      } catch (err) {
        console.error("Error fetching store data:", err);
        setStoreError(err.message);
        NotificationManager.error(
          "Failed to load store options",
          "Error",
          3000
        );
      } finally {
        setIsLoadingStores(false);
      }
    };

    fetchStoreData();
  }, []);

  // Fetch service level data
  useEffect(() => {
    const fetchServiceLevelData = async () => {
      setIsLoadingServiceLevels(true);
      setServiceLevelError(null);

      try {
        const response = await ServiceLevelService.fetchServiceLevel(1, 100);

        const { data } = response;
        setServiceLevelOptions(
          data.map((level) => ({
            id: level.service_level_id,
            name: `${level.service_level}`,
          }))
        );
      } catch (err) {
        console.error("Error fetching service level data:", err);
        setServiceLevelError(err.message);
        NotificationManager.error(
          "Failed to load service level options",
          "Error",
          3000
        );
      } finally {
        setIsLoadingServiceLevels(false);
      }
    };

    fetchServiceLevelData();
  }, []);

  // Field mapping between API response and form fields
  const fieldMapping = {
    department_id: "department_number",
    // supplier_site_id: "supplier_site_id",
    vendor_name: "vendor_name",

    // Only this one matches
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form data
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "freight_payer_id" && value === "Vendor") {
      const updatedErrors = { ...fieldErrors };
      delete updatedErrors.expense_number;
      setFieldErrors(updatedErrors);
    }

    // Reset specific error for the current field
    const updatedErrors = { ...fieldErrors };
    delete updatedErrors[name];

    // Field-specific validations
    switch (name) {
      case "po_number":
        if (!value) updatedErrors.po_number = "PO Number is required";
        break;

      case "vendor_name":
        if (!value) updatedErrors.vendor_name = "Vendor Name is required";
        else if (typeof value !== "string")
          updatedErrors.vendor_name = "Vendor Name must be a string";
        break;

      case "department_number":
        if (!value)
          updatedErrors.department_number = "Department Number is required";
        else if (isNaN(Number(value)))
          updatedErrors.department_number =
            "Department Number must be a number";
        break;

      case "requester_name":
        if (!value) updatedErrors.requester_name = "Requester Name is required";
        else if (typeof value !== "string")
          updatedErrors.requester_name = "Requester Name must be a string";
        break;

      case "requester_phone":
        if (!value)
          updatedErrors.requester_phone = "Requester Phone is required";
        else if (!/^\d+$/.test(value))
          updatedErrors.requester_phone =
            "Requester Phone must contain only digits";
        break;

      case "requester_email":
        if (!value)
          updatedErrors.requester_email = "Requester Email is required";
        else if (
          !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(value) ||
          /\.{2,}/.test(value)
        )
          updatedErrors.requester_email =
            "Requester Email must be a valid email address";
        break;

      case "units":
        if (value && isNaN(Number(value))) {
          updatedErrors.units = "Units must be a number";
        }
        break;

      case "vendor_email":
        if (value && !/\S+@\S+\.\S+/.test(value)) {
          updatedErrors.vendor_email =
            "Vendor Email must be a valid email address";
        }
        break;
    }

    // Update field errors
    setFieldErrors(updatedErrors);
  };
  const handleDateChange = (newDate) => {
    setFormData((prevData) => ({
      ...prevData,
      approved_date: newDate ? dayjs(newDate).format("YYYY-MM-DD") : null,
    }));
    setErrors((prevErrors) => ({ ...prevErrors, approved_date: "" }));
  };

  const validateForm = () => {
    const errors = {};

    // Required fields
    if (!formData.po_number) {
      errors.po_number = "PO Number is required";
    } else if (typeof formData.po_number !== "string") {
      errors.po_number = "PO Number must be a string";
    }

    if (!formData.vendor_name) {
      errors.vendor_name = "Vendor Name is required";
    } else if (typeof formData.vendor_name !== "string") {
      errors.vendor_name = "Vendor Name must be a string";
    }

    if (!formData.department_number) {
      errors.department_number = "Department Number is required";
    } else if (typeof formData.department_number !== "number") {
      errors.department_number = "Department Number must be a number";
    }

    if (
      !Array.isArray(formData.store_list) ||
      formData.store_list.length === 0
    ) {
      errors.store_list = "Store List is required";
    }

    if (!formData.service_level_id) {
      errors.service_level_id = "Service Level is required";
    } else if (typeof formData.service_level_id !== "number") {
      errors.service_level_id = "Service Level must be a number";
    }
    if (!formData.freight_payer_id) {
      errors.freight_payer_id = "freight payer id is required";
    } else if (typeof formData.freight_payer_id !== "string") {
      errors.freight_payer_id = "freight payer id must be a number";
    }
    if (!formData.exception_routing_reason) {
      errors.exception_routing_reason = "exception routing reason is required";
    } else if (typeof formData.exception_routing_reason !== "string") {
      errors.exception_routing_reason =
        "exception routing reason must be a string";
    }

    if (!formData.requester_name) {
      errors.requester_name = "Requester Name is required";
    } else if (typeof formData.requester_name !== "string") {
      errors.requester_name = "Requester Name must be a string";
    }

    if (!formData.requester_phone) {
      errors.requester_phone = "Requester Phone is required";
    } else if (!/^\d+$/.test(formData.requester_phone)) {
      errors.requester_phone = "Requester Phone must contain only digits";
    }

    // if (!formData.requester_email) {
    //   errors.requester_email = "Requester Email is required";
    // } else if (
    //   !/^[^\s@]+@[^\s@]+\.(com|org|net|edu|gov|mil|io|info|co)$/i.test(formData.requester_email)
    // ) {
    //   errors.requester_email = "Requester Email must be a valid email address with a common domain";
    // }

    if (!formData.requester_email) {
      errors.requester_email = "Requester Email is required";
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(formData.requester_email) ||
      /\.{2,}/.test(formData.requester_email)
    ) {
      errors.requester_email = "Requester Email must be a valid email address";
    }

    if (formData.units && isNaN(Number(formData.units))) {
      errors.units = "Units must be a number";
    }

    // Optional fields (validate only if provided)
    if (formData.client_name && typeof formData.client_name !== "string") {
      errors.client_name = "Client Name must be a string";
    }

    if (formData.vendor_email && !/\S+@\S+\.\S+/.test(formData.vendor_email)) {
      errors.vendor_email = "Vendor Email must be a valid email address";
    }

    if (
      formData.freight_payer_id &&
      typeof formData.freight_payer_id !== "string"
    ) {
      errors.freight_payer_id = "Freight Payer ID must be a number";
    }

    // if (
    //   formData.exception_routing_reason = "" || typeof formData.exception_routing_reason!== "string" || formData.exception_routing_reason.length > 1
    // ) {
    //   errors.exception_routing_reason =
    //     "Exception Routing Reason must be a string";
    // }

    if (
      !formData.vendor_ship_date &&
      isNaN(Date.parse(formData.vendor_ship_date))
    ) {
      errors.vendor_ship_date =
        "Vendor Ready to Ship Date must be a valid date";
    }

    if (!formData.date_needed_store) {
      errors.date_needed_store = "Date Needed in Store is required.";
    }

    if (["Buyer", "Store"].includes(formData.freight_payer_id)) {
      if (!formData.expense_number) {
        errors.expense_number =
          "Expense Number is required when Freight Payer is Buyer or Store";
      }
    }

    setFieldErrors(errors);

    // Return true if no errors
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting form data:", formData);

    if (!validateForm()) {
      console.log("Validation failed. Stopping submission.");
      return;
    }

    // Set loading to true at the beginning of submission
    setLoading(true);

    try {
      const response = await createPO(formData);

      console.log("API Response:", response);
      if (response?.ErrorMessage) {
        const cleanedErrorMessage = response.ErrorMessage.replace(/\\"/g, '"');
        console.log("Error message from API:", cleanedErrorMessage);
        NotificationManager.error(cleanedErrorMessage, "Error", 4000);
      } else if (response?.message) {
        console.log("Success message found:", response.message);
        NotificationManager.success(
          "Exception Request Submitted",
          "Success",
          4000
        );
        setFormData(initialFormData);
        setErrors({});
        setFieldErrors({});
      } else {
        console.log("No ErrorMessage or message found in the response");
        NotificationManager.error("Error creating PO", "Error", 4000);
      }
    } catch (error) {
      console.error("Error in submission:", error);
      if (error.response && error.response.data?.ErrorMessage) {
        const apiErrorMessage = error.response.data.ErrorMessage.replace(
          /\\"/g,
          '"'
        );
        console.log("API returned an error:", apiErrorMessage);
        NotificationManager.error(apiErrorMessage, "Error", 4000);
      } else {
        NotificationManager.error(
          "An error occurred while submitting the form. Please try again.",
          "Error",
          4000
        );
      }
    } finally {
      // Always set loading to false when done, whether successful or not
      setLoading(false);
    }
  };

  useEffect(() => {
    setFieldErrors({});
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData(initialFormData);
    }
  }, [initialData, open]);

  const handlePoNumberBlur = async () => {
    const { po_number } = formData;
    if (!po_number) {
      setPoError("PO number cannot be empty.");
      setIsFormDisabled(false);
      return;
    }
    setLoading(true);
    try {
      const poData = await checkPONumber(po_number);
      console.log("API Response:", poData);

      if (poData.data && poData.data.length > 0) {
        const updatedFields = {};

        Object.entries(fieldMapping).forEach(([apiField, formField]) => {
          if (
            poData.data[0][apiField] !== undefined &&
            poData.data[0][apiField] !== null
          ) {
            updatedFields[formField] = poData.data[0][apiField];
          }
        });

        if (poData.data[0].start_ship_date) {
          updatedFields.approved_date = dayjs(
            poData.data[0].start_ship_date
          ).format("YYYY-MM-DD");
        }

        setFormData((prevData) => ({
          ...prevData,
          ...updatedFields,
        }));
        setPoError("");
        setIsFormDisabled(false);
      } else {
        console.log("No data returned for PO number:", po_number);
        setPoError("Invalid PO number. Please enter a valid PO number.");
        setIsFormDisabled(true);
      }
    } catch (error) {
      console.error("Error fetching PO data:", error);
      setPoError("An error occurred while validating the PO number.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="store-page-container">
      <div>
        <NotificationContainer></NotificationContainer>
      </div>

      <div className="store-container">
        {loading && (
          <Box
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            display="flex"
            justifyContent="center"
            alignItems="center"
            bgcolor="rgba(255, 255, 255, 0.8)"
            zIndex={9999}
            width="100%"
            height="120%"
          >
            <Box display="flex">
              <img src={loaderGif} alt="Loading..." width={50} height={50} />
            </Box>
          </Box>
        )}

        <h2 className="theme-color">
          DTS PO Exception Routing Request Guidelines
        </h2>
        <p className="email">
          <strong>
            Approvals for DTS PO exception routing requests should be e-mailed
            to:
          </strong>
        </p>
        <p className="email">Exception_Routing@neimanmarcus.com</p>

        <h2>DTS PO Exceptions</h2>
        <p>
          Direct to Store (DTS) PO exceptions are requests from the vendor or
          NM/BG to ship a PO to a store location instead of allocating through a
          warehouse facility. All exceptions require approval before the vendor
          can ship DTS. The procedures and requirements are outlined below.
        </p>

        <h3>Domestic Brands</h3>
        <ul>
          <li>
            All requests must be accompanied by an approval email from the GMM
            (buying office) or Sr. RPSO/GM (store) to{" "}
            <a href="mailto:Exception_Routing@neimanmarcus.com">
              Exception_Routing@neimanmarcus.com
            </a>{" "}
            within 4 hours of submission through the portal.
          </li>
          <li>
            If approved, an email will be sent from{" "}
            <a href="mailto:Exception_Routing@neimanmarcus.com">
              Exception_Routing@neimanmarcus.com
            </a>{" "}
            to the original requestor with an authorization # to be shared with
            the vendor.
          </li>
          <li>
            If a PO is not systemically received within 2 weeks of delivery, the
            buying office must email{" "}
            <a href="mailto:Pipeline_StoreOps@neimanmarcus.com">
              Pipeline_StoreOps@neimanmarcus.com
            </a>{" "}
            with the PO#, store #, packing slip, and POD.
          </li>
        </ul>

        <h3>PO Submission Requirements</h3>
        <ul>
          <li>
            A PO must be written to a store location, not a warehouse location.
            <ul>
              <li>
                SPORT POs default to DTS shipments; however, PORT POs must be
                manually adjusted to ship DTS. Keying a DTS PO in PORT.
              </li>
              <li>
                In PORT, select “SO” for PO Type. Refer to the SPORT/PORT
                Tipsheet for guidance.
              </li>
            </ul>
          </li>
          <li>
            One PO# per store location. Each PO cannot exceed 10 SKUs or 30
            units in total.
          </li>
          <li>
            DTS PO exception requests must be submitted with an expected store
            arrival date of no more than 14 days from the initial request.
          </li>
          <li>
            If NMG is paying for freight:
            <ul>
              <li>
                An active GL expense account must be provided. Verify the
                account is valid.
              </li>
              <li>
                All requests must ship FedEx Ground unless approval for
                expedited shipping is granted by the GMM (buying office) or Sr.
                RPSO/GM (store).
              </li>
            </ul>
          </li>
        </ul>

        <p className="email">
          <strong>
            Approvals for DTS PO exception routing requests should be e-mailed
            to:
          </strong>
        </p>
        <p className="email">Exception_Routing@neimanmarcus.com</p>

        <p className="note">
          NOTE: Do not use special characters other than a DASH (-) or PERIOD
          (.) when filling in any field.
        </p>
      </div>

      <div className="form-container">
        <h2 className="theme-color">DTS PO Exception Routing Request</h2>
        <Box
          component="form"
          noValidate
          autoComplete="off"
          onSubmit={handleSubmit}
        >
          <Grid container spacing={2} style={{ height: "80vh" }}>
            <TextField
              margin="dense"
              required
              fullWidth
              id="po_number"
              name="po_number"
              label="PO"
              variant="outlined"
              value={formData.po_number}
              onChange={handleChange}
              onBlur={handlePoNumberBlur}
              error={!!poError}
              helperText={poError}
            />
            {/* {fieldErrors.po_number && <div style={{ color: 'red', fontSize: '0.875rem' }}>{fieldErrors.po_number}</div>} */}

            <TextField
              margin="dense"
              required
              fullWidth
              id="vendor_name"
              name="vendor_name"
              label="Vendor Name"
              variant="outlined"
              value={formData.vendor_name}
              onChange={handleChange}
              disabled={isFormDisabled}
            />
            {fieldErrors.vendor_name && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.vendor_name}
              </div>
            )}

            <TextField
              margin="dense"
              required
              fullWidth
              id="department_number"
              name="department_number"
              label="Dept"
              variant="outlined"
              value={formData.department_number}
              onChange={handleChange}
              disabled={isFormDisabled}
            />
            {fieldErrors.department_number && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.department_number}
              </div>
            )}

            <Select
              margin="dense"
              required
              fullWidth
              id="store_list"
              name="store_list"
              variant="outlined"
              value={formData.store_list || []}
              onChange={(e) => {
                const { value } = e.target;
                setFormData((prevData) => ({
                  ...prevData,
                  store_list: value,
                }));
              }}
              error={!!errors.store_list}
              displayEmpty
              renderValue={(selected) =>
                selected.length > 0 ? (
                  storeOptions
                    .filter((store) => selected.includes(store.number)) // Match selected store numbers
                    .map((store) => ` ${store.name}`) // Combine number and name
                    .join(", ")
                ) : (
                  <span style={{ color: "#999999" }}>Select store *</span>
                )
              }
              multiple
            >
              <MenuItem disabled value="">
                Select a store
              </MenuItem>
              {storeOptions.map((store) => (
                <MenuItem key={store.number} value={store.number}>
                  <Checkbox
                    checked={formData.store_list?.includes(store.number)}
                  />
                  <ListItemText primary={`${store.name}`} />
                </MenuItem>
              ))}
              disabled={isFormDisabled}
            </Select>
            {fieldErrors.store_list && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.store_list}
              </div>
            )}
            <TextField
              margin="dense"
              fullWidth
              id="units"
              name="units"
              label="Units"
              variant="outlined"
              value={formData.units}
              onChange={handleChange}
              disabled={isFormDisabled}
            />
            {fieldErrors.units && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.units}
              </div>
            )}
            <TextField
              margin="dense"
              fullWidth
              id="client_name"
              name="client_name"
              label="Client Name"
              variant="outlined"
              value={formData.client_name}
              onChange={handleChange}
              disabled={isFormDisabled}
            />
            {fieldErrors.client_name && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.client_name}
              </div>
            )}
            <TextField
              margin="dense"
              fullWidth
              id="vendor_email"
              name="vendor_email"
              label="Vendor Email"
              variant="outlined"
              value={formData.vendor_email}
              onChange={handleChange}
              disabled={isFormDisabled}
            />
            {fieldErrors.vendor_email && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.vendor_email}
              </div>
            )}
            <TextField
              margin="dense"
              required
              fullWidth
              name="freight_payer_id"
              id="freight_payer_id"
              select
              label="Freight Payer"
              variant="outlined"
              value={formData.freight_payer_id}
              onChange={handleChange}
              disabled={isFormDisabled}
            >
              {freightPayerOptions.map((option) => (
                <MenuItem key={option.id} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            {fieldErrors.freight_payer_id && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.freight_payer_id}
              </div>
            )}
            {/* <TextField
              margin="dense"
              fullWidth
              name="bill_account_number"
              id="bill_account_number"
              select
              label="Bill to Account"
              variant="outlined"
              value={formData.bill_account_number}
              onChange={handleChange}
              disabled={isFormDisabled}
            >
              {billToAccountOptions.map((option) => (
                <MenuItem key={option.id} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField> */}
            <TextField
              margin="dense"
              required
              fullWidth
              name="service_level_id" // Changed from id to name
              id="service_level_id"
              select
              label="Service Level"
              variant="outlined"
              value={formData.service_level_id}
              onChange={handleChange}
              disabled={isLoadingServiceLevels}
              style={{ color: "#999999" }}
              // disabled={isFormDisabled}
            >
              {isLoadingServiceLevels ? (
                <MenuItem disabled>Loading service levels...</MenuItem>
              ) : (
                serviceLevelOptions.map((level) => (
                  <MenuItem key={level.id} value={level.id}>
                    {level.name}
                  </MenuItem>
                ))
              )}
            </TextField>
            {fieldErrors.service_level_id && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.service_level_id}
              </div>
            )}

            <TextField
              margin="dense"
              fullWidth
              required={["Buyer", "Store"].includes(formData.freight_payer_id)}
              id="expense_number"
              name="expense_number"
              label={`Expense Number${
                ["Buyer", "Store"].includes(formData.freight_payer_id)
                  ? " "
                  : ""
              }`}
              variant="outlined"
              value={formData.expense_number}
              onChange={handleChange}
              disabled={isFormDisabled}
              error={!!fieldErrors.expense_number}
              helperText={fieldErrors.expense_number}
            />

            <TextField
              margin="dense"
              required
              fullWidth
              //id="requester_name"
              name="requester_name"
              label="Requester Name"
              variant="outlined"
              value={formData.requester_name}
              onChange={handleChange}
              style={{ color: "#999999" }}
              disabled={isFormDisabled}
            />
            {fieldErrors.requester_name && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.requester_name}
              </div>
            )}

            <TextField
              margin="dense"
              required
              fullWidth
              id="requester_phone"
              name="requester_phone"
              label="Requester Phone"
              variant="outlined"
              value={formData.requester_phone}
              onChange={handleChange}
              disabled={isFormDisabled}
            />
            {fieldErrors.requester_phone && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.requester_phone}
              </div>
            )}

            <TextField
              margin="dense"
              required
              fullWidth
              id="requester_email"
              name="requester_email"
              label="Requester Email"
              variant="outlined"
              type="email"
              value={formData.requester_email}
              onChange={handleChange}
              disabled={isFormDisabled}
            />
            {fieldErrors.requester_email && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.requester_email}
              </div>
            )}

            {/* <TextField
              multiline
              rows={4}
              margin="dense"
              label="Comment"
              id="comment"
              fullWidth
              value={formData.comment}
              onChange={(e) =>
                setFormData((prevData) => ({
                  ...prevData,
                  comment: e.target.value,
                }))
              }
              disabled={isFormDisabled}
            />
            {fieldErrors.comment && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.comment}
              </div>
            )} */}

            <TextField
              margin="dense"
              required
              fullWidth
              name="exception_routing_reason"
              id="exception_routing_reason"
              select
              label="Reason for exception routing"
              variant="outlined"
              value={formData.exception_routing_reason}
              onChange={handleChange}
              disabled={isLoadingServiceLevels}
            >
              {exceptionRoutingOptions.map((option) => (
                <MenuItem key={option.id} value={option.name}>
                  {option.name}
                </MenuItem>
              ))}
            </TextField>
            {fieldErrors.exception_routing_reason && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.exception_routing_reason}
              </div>
            )}

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="my-1"
                required
                fullWidth
                value={
                  formData.approved_date ? dayjs(formData.approved_date) : null
                }
                onChange={handleDateChange}
                label="Approved Date"
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            {fieldErrors.approved_date && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.approved_date}
              </div>
            )}

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="my-1"
                required
                fullWidth
                value={
                  formData.vendor_ship_date
                    ? dayjs(formData.vendor_ship_date)
                    : null
                }
                onChange={(newValue) => {
                  setFormData((prevData) => ({
                    ...prevData,
                    vendor_ship_date: newValue
                      ? newValue.format("YYYY-MM-DD")
                      : null,
                  }));
                }}
                label="Vendor Ready to Ship"
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            {fieldErrors.vendor_ship_date && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.vendor_ship_date}
              </div>
            )}

            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                className="my-1"
                required
                fullWidth
                value={
                  formData.date_needed_store
                    ? dayjs(formData.date_needed_store)
                    : null
                }
                onChange={(newValue) => {
                  setFormData((prevData) => ({
                    ...prevData,
                    date_needed_store: newValue
                      ? newValue.format("YYYY-MM-DD")
                      : null,
                  }));
                }}
                label="Date needed in store"
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            {fieldErrors.date_needed_store && (
              <div style={{ color: "red", fontSize: "0.875rem" }}>
                {fieldErrors.date_needed_store}
              </div>
            )}

            <Button
              variant="contained"
              color="primary"
              fullWidth
              type="submit"
              onClick={handleSubmit}
              disabled={loading} // Disable button while loading
            >
              {loading ? (
                <React.Fragment>
                  <CircularProgress
                    size={24}
                    style={{ marginRight: "10px", color: "white" }}
                  />
                  Submitting...
                </React.Fragment>
              ) : (
                "Submit"
              )}
            </Button>
          </Grid>
        </Box>
      </div>
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <CircularProgress />
        </div>
      )}
    </div>
  );
};

export default Store;
